/**
 * @internal
 */
export var getHttpStoreKey = function (url, options) {
    var method = (options.method || 'GET').toLowerCase();
    var key = method + ":" + url;
    if (options.body) {
        key += ":" + options.body;
    }
    return key;
};
